module.exports = __webpack_public_path__ + "img/icon_password.c18725ed.svg";